import ButtonFunction from "./shared/ButtonFunction";
import TextInputHorizontalTag from "./shared/TextInputHorizontalTag";
import NavLabel from "./shared/NavLabel";
import GeneralContext from "../context/GeneralContext";
import { useContext, useState } from "react";
import {fetchBody} from '../utils/fetch';

function PassNewPassCard() {

  const {
    changeActiveMode,
    changeModalTitle,
    changeModalText,
    changeModalType,
    activePasswordId
  } = useContext(GeneralContext);

  const [password, setPassword] = useState("");
  const changePassword = (e) => {
    setPassword(e.target.value);
  }

  const [passwordConfirm, setPasswordConfirm] = useState("");
  const changePasswordConfirm = (e) => {
    setPasswordConfirm(e.target.value);
  }

  const newPasswordFunction = async () => {
    const modal = document.getElementById("myModal");
    if (password === '' || passwordConfirm === '') {
      changeModalTitle('Error');
      changeModalText('Los campos no pueden estar vacíos');
      changeModalType('alert');
      modal.style.display = "block";
    } else {
      if (password !== passwordConfirm) {
        changeModalTitle('Error');
        changeModalText('Las contraseñas no coinciden');
        changeModalType('alert');
        modal.style.display = "block";
        return false;
      }
      const data = {id: activePasswordId, password: password};
      const response = await fetchBody('change_forgotten_password', 'PUT', data);
      if (response.success) {
        changeModalTitle('Éxito!');
        changeModalText('Las contraseñas se ha restablecido exitosamente');
        changeModalType('alert');
        modal.style.display = "block";
        changeActiveMode('login');
      } else {
        changeModalTitle('Error al intentar la operación');
        changeModalText(response.reason);
        changeModalType('alert');
        modal.style.display = "block";
      }
    }
  }

  const loginMode = () => {
    changeActiveMode('login');
  }

  return (
    <div id='loginCard'>
      <>
        <h2>Ingrese la nueva contraseña</h2>
        <TextInputHorizontalTag label='Contraseña' type='password' changeEvent={changePassword}/>
        <br />
        <TextInputHorizontalTag label='Confirmar contraseña' type='password' changeEvent={changePasswordConfirm}/>
        <br />
        <ButtonFunction buttonClass='loginButton' buttonFunction={newPasswordFunction}>Terminar</ButtonFunction>
        <br />
        <br />
        <NavLabel navFunction={loginMode}>Regresar a ingreso</NavLabel>
      </>
    </div>
  )
}

export default PassNewPassCard